import { BaseContext } from '../../../../utils/basecontext';
import { APIModel, APIModelHandler, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { FeaturedCategoryDtoImpl } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { CategoriesProcessorFactory } from '../../../../core/processorfactory/categoriesprocessorfactory';
import { CategoryDtoImpl, CategoryDto } from '../../../../core/dto/categories/categorydto';
import { CategoriesResponse } from '../../../../core/api/categories/categoriesresponse';
import { CategoriesRequestImpl } from '../../../../core/api/categories/categoriesrequest';
import { SubCategoriesDto } from '../../../../core/dto/categories/subcategorydto';
import { SearchToneDtoImpl } from '../../../../core/dto/searchtone/searchtonedto';
import { SearchToneResponse } from '../../../../core/api/search/searchtone/searchtoneresponse';
import { SearchToneRequestImpl } from '../../../../core/api/search/searchtone/searchtonerequest';
import { CategoriesListComponent } from './categorieslistcomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface CategoriesListAPIModel extends APIModel
{
    getCategories(categoryName: string): void;
    getLoadMoreFeatureCategoriesTones(categoryId: number, title: string, startIndex: number, offset: number): void;
}

export class CategoriesListAPIModelImpl extends APIModelImpl implements CategoriesListAPIModel
{
    private categoriesProcessorFactory: CategoriesProcessorFactory;
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.categoriesProcessorFactory = this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory();
    }

    getCategories(categoryName: string): void 
    {
        let categoryDto = new CategoryDtoImpl();
        categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
       this.categoriesProcessorFactory.getCategories()
                   .success((categoriesResponse : CategoriesResponse)=>
                    {
                       let categoryDto1 = this.getSelectedCategoryFromList(categoryName, 
                        categoriesResponse.getCategoriesList());

                        if(categoryDto1 !== undefined)
                        {
                            this.getFeaturedCategories(categoryDto1);
                        }
                        else
                        {
                            this.getAPIModelHandler().onFailure(categoriesResponse.getAPIFeature(), 
                            this.getContext().getResources().getString(Strings.no_data_list_available), categoriesResponse);
                        }
                    })
                  .failure((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(categoriesResponse.getAPIFeature(), 
                      categoriesResponse.getDescription(), categoriesResponse);
                    })
                  .execute(new CategoriesRequestImpl(categoryDto));
    }

    getLoadMoreFeatureCategoriesTones(categoryId: number, title: string, startIndex: number, offset: number): void 
    {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(offset);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        //searchToneDto.setSearchKey("Recently+Added"); 
        searchToneDto.setSearchKey(title); 
        searchToneDto.setCategoryId(categoryId);
        searchToneDto.setSortBy("Order_By");
        searchToneDto.setAlignBy("ASC");
        searchToneDto.setPageNo(startIndex);
        searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getSearchTone()
        .success((searchToneResponse: SearchToneResponse)=>
        {
            let featuredCategorydto = new FeaturedCategoryDtoImpl();
            featuredCategorydto.setCategoryId(categoryId);
            featuredCategorydto.setTitle(title);
            featuredCategorydto.setListOfTones(searchToneResponse.getListOfSearchToneDtos().getListOfTones());

            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), featuredCategorydto);

         })
        .failure((searchToneResponse : SearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), searchToneResponse);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    private getFeaturedCategories(categoryDto: CategoryDto): void 
    {   
        if(categoryDto.getSubCategoriesList() !== undefined)
        {
            (this.getAPIModelHandler() as CategoriesListComponent).updateCount(categoryDto.getSubCategoriesList().length);
            categoryDto.getSubCategoriesList().forEach((subCategoryDto: SubCategoriesDto) =>
            {
                console.log("invokeCategoryClick() invoked");

                this.getLoadMoreFeatureCategoriesTones(+subCategoryDto.getSubCdpCategoryId(),
                subCategoryDto.getCategoryName(), 0, 20);
            });
        }
        else
        {
            (this.getAPIModelHandler() as CategoriesListComponent).updateCount(1);
            this.getLoadMoreFeatureCategoriesTones(+categoryDto.getId(), categoryDto.getTitle(), 0, 20);
        }
    }   

    private getSelectedCategoryFromList(categoryName: String, listOfCategories: CategoryDto[]): CategoryDto | undefined
    {
       return listOfCategories.find((categoryDto: CategoryDto) => {
            return categoryDto.getTitle() === categoryName;
        });
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categorieslist/categoriesapimodel.tsx